var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreateSettlementIcon = function SvgCreateSettlementIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56 12.25a.75.75 0 0 1 .75.75v5a.75.75 0 1 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 15.5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM8 1.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V2A.75.75 0 0 1 8 1.25ZM16 1.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.795 2.67h.042c1.732.063 3.241.414 4.3 1.545 1.046 1.116 1.502 2.833 1.553 5.24l.13 6.17c.04 2.07-.16 3.869-1.199 5.142-1.064 1.307-2.835 1.866-5.404 1.923l-6.002.12c-2.57.051-4.364-.437-5.482-1.7-1.09-1.23-1.363-3.019-1.403-5.084v-.001l-.14-6.179c-.051-2.407.335-4.142 1.335-5.3C4.537 3.374 6.03 2.962 7.754 2.832a.76.76 0 0 1 .041-.002l8-.16Zm-7.95 1.66c-1.585.121-2.57.484-3.185 1.196-.63.73-1.019 1.995-.97 4.288l.14 6.181c.04 2.045.326 3.33 1.027 4.122.672.76 1.898 1.242 4.328 1.193l5.998-.12c2.431-.053 3.635-.584 4.276-1.37.666-.819.9-2.115.861-4.165l-.13-6.169c-.049-2.294-.488-3.542-1.147-4.246-.644-.686-1.643-1.01-3.24-1.07l-7.957.16Z",
    fill: "#fff"
  })));
};
export default SvgCreateSettlementIcon;